module.exports = __webpack_public_path__ + "img/header_logo_mckinsey.b9e5345c.png";